import { c as _c } from "react-compiler-runtime";
import { mergeRefs } from "@react-aria/utils";
import React from "react";
import { ButtonContext, Group, InputContext, LabelContext, OverlayTriggerStateContext, PopoverContext, Provider, SelectContext, useSlottedContext } from "react-aria-components";
import { useFieldErrorContext } from "../../context.js";
import { Spinner } from "../Spinner.js";
import { useSuccessSpinnerState } from "../internal/useSuccessSpinnerState.js";
import { AvatarContext } from "./AvatarContext.js";
import ErrorIcon from "./ErrorIcon.js";
import * as styles from "./InputBuilder.css.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BaseInputBuilder = (t0, externalRef) => {
  const $ = _c(64);
  const {
    slot,
    left,
    children,
    right,
    size: t1,
    loadingState,
    leadingText,
    isDisabled: isDisabledProp
  } = t0;
  const size = t1 === undefined ? "m" : t1;
  const triggerRef = React.useRef(null);
  const existingInput = useSlottedContext(InputContext, slot);
  const existingSelect = useSlottedContext(SelectContext, slot);
  const existingButton = useSlottedContext(ButtonContext, slot);
  const existingPopover = useSlottedContext(PopoverContext, slot);
  const validation = useFieldErrorContext();
  const existingLabel = useSlottedContext(LabelContext, slot);
  const {
    renderState,
    startAnimation
  } = useSuccessSpinnerState(loadingState);
  const isError = validation?.isInvalid === true || loadingState === "error";
  const isOpen = React.useContext(OverlayTriggerStateContext)?.isOpen === true;
  let t2;
  bb0: {
    if (typeof right === "function") {
      let t3;
      if ($[0] !== isError || $[1] !== isOpen || $[2] !== loadingState || $[3] !== renderState || $[4] !== right || $[5] !== startAnimation) {
        t3 = right({
          isError,
          isOpen,
          loadingState,
          loadingRenderState: renderState,
          loadingStartAnimation: startAnimation
        });
        $[0] = isError;
        $[1] = isOpen;
        $[2] = loadingState;
        $[3] = renderState;
        $[4] = right;
        $[5] = startAnimation;
        $[6] = t3;
      } else {
        t3 = $[6];
      }
      t2 = t3;
      break bb0;
    }
    t2 = right;
  }
  const rightContent = t2;
  const isDisabled = isDisabledProp ?? existingInput?.disabled ?? undefined;
  let t3;
  if ($[7] !== externalRef) {
    t3 = mergeRefs(externalRef, triggerRef);
    $[7] = externalRef;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = existingLabel?.id;
  let t5;
  if ($[9] !== isError || $[10] !== size) {
    t5 = styles.container({
      size,
      isError
    });
    $[9] = isError;
    $[10] = size;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [[AvatarContext, {
      size: "xxs",
      isInteractive: false,
      tooltip: false,
      insideInputBuilder: true
    }]];
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== left) {
    t7 = typeof left === "function" ? /*#__PURE__*/React.createElement(left, {
      className: styles.leftIcon
    }) : left;
    $[13] = left;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = /*#__PURE__*/_jsx(Provider, {
      values: t6,
      children: t7
    });
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== leadingText || $[18] !== size) {
    t9 = leadingText != null && /*#__PURE__*/_jsx("span", {
      "aria-hidden": true,
      className: styles.leadingText({
        size
      }),
      children: leadingText
    });
    $[17] = leadingText;
    $[18] = size;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== size) {
    t10 = styles.input({
      size
    });
    $[20] = size;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== existingInput || $[23] !== t10) {
    t11 = [InputContext, {
      ...existingInput,
      className: t10
    }];
    $[22] = existingInput;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== existingSelect) {
    t12 = [SelectContext, {
      ...existingSelect,
      className: styles.select
    }];
    $[25] = existingSelect;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== size) {
    t13 = styles.input({
      size
    });
    $[27] = size;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== existingButton || $[30] !== t13) {
    t14 = [ButtonContext, {
      ...existingButton,
      className: t13
    }];
    $[29] = existingButton;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== existingPopover) {
    t15 = [PopoverContext, {
      ...existingPopover,
      triggerRef
    }];
    $[32] = existingPopover;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t11 || $[35] !== t12 || $[36] !== t14 || $[37] !== t15) {
    t16 = [t11, t12, t14, t15];
    $[34] = t11;
    $[35] = t12;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== children || $[40] !== t16) {
    t17 = /*#__PURE__*/_jsx("div", {
      role: "presentation",
      className: styles.inputWrapper,
      children: /*#__PURE__*/_jsx(Provider, {
        values: t16,
        children: children
      })
    });
    $[39] = children;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== loadingState || $[43] !== renderState || $[44] !== right || $[45] !== startAnimation) {
    t18 = loadingState != null && typeof right !== "function" && /*#__PURE__*/_jsx(Spinner, {
      state: loadingState,
      renderState: renderState,
      startAnimation: startAnimation,
      size: "s",
      color: "royalBlue"
    });
    $[42] = loadingState;
    $[43] = renderState;
    $[44] = right;
    $[45] = startAnimation;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== isError || $[48] !== loadingState || $[49] !== right) {
    t19 = isError && loadingState !== "error" && typeof right !== "function" && /*#__PURE__*/_jsx(ErrorIcon, {});
    $[47] = isError;
    $[48] = loadingState;
    $[49] = right;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] !== rightContent || $[52] !== t18 || $[53] !== t19) {
    t20 = /*#__PURE__*/_jsxs(Group, {
      role: "presentation",
      className: styles.buttonGroup,
      children: [t18, t19, rightContent]
    });
    $[51] = rightContent;
    $[52] = t18;
    $[53] = t19;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  let t21;
  if ($[55] !== isDisabled || $[56] !== t17 || $[57] !== t20 || $[58] !== t3 || $[59] !== t4 || $[60] !== t5 || $[61] !== t8 || $[62] !== t9) {
    t21 = /*#__PURE__*/_jsxs(Group, {
      ref: t3,
      "aria-labelledby": t4,
      className: t5,
      isDisabled: isDisabled,
      children: [t8, t9, t17, t20]
    });
    $[55] = isDisabled;
    $[56] = t17;
    $[57] = t20;
    $[58] = t3;
    $[59] = t4;
    $[60] = t5;
    $[61] = t8;
    $[62] = t9;
    $[63] = t21;
  } else {
    t21 = $[63];
  }
  return t21;
};
export const InputBuilder = /*#__PURE__*/React.forwardRef(BaseInputBuilder);
//# sourceMappingURL=InputBuilder.js.map